require('aframe');
require('@fern-solutions/aframe-3dof');